// CPF AND CNPJ
export const validateIdentification = (id: string): boolean => {
  if (id.length === 11) {
    const validators = [0, 0];
    for (let i = 0; i < 9; i++) {
      const digit = Number.parseInt(id.charAt(i));
      validators[0] += (i + 1) * digit;
      validators[1] += i * digit;
    }
    validators[0] = (validators[0] % 11) % 10;
    validators[1] = ((validators[1] + 9 * validators[0]) % 11) % 10;

    return (
      `${validators[0]}` === id.charAt(9) &&
      `${validators[1]}` === id.charAt(10)
    );
  }

  if (id.length === 14) {
    const validators = [0, 0];
    const validatorMultipliers = [5, 6, 7, 8, 9, 2, 3, 4, 5, 6, 7, 8, 9];
    for (let i = 0; i < 12; i++) {
      const digit = Number.parseInt(id.charAt(i));
      validators[0] += validatorMultipliers[i + 1] * digit;
      validators[1] += validatorMultipliers[i] * digit;
    }
    validators[0] = (validators[0] % 11) % 10;
    validators[1] = ((validators[1] + 9 * validators[0]) % 11) % 10;

    return (
      `${validators[0]}` === id.charAt(12) &&
      `${validators[1]}` === id.charAt(13)
    );
  }

  return false;
};